import React from 'react'
import { Link } from 'gatsby'

const YellowButton = ({ to, children, className }) => (
<Link to={to} className={`${className ? className : ''} px-10 py-3 border border-transparent text-sm leading-6 font-normal uppercase tracking-wider rounded-sm text-gray-900 bg-yellow-300 hover:bg-yellow-200 focus:outline-none focus:shadow-outline focus:border-indigo-300 transition duration-150 ease-in-out`}>{children}</Link>
)

export default YellowButton